import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';

const MATCH2_RACES = 'match2 Races';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_RACES] = [
    {
      text: 'Win Current Race',
      color: 'secondary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_winCurrentRace();
      },
    },
    {
      text: 'Reset Races',
      color: 'secondary',
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_resetRaces();
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_RACES:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2RacesCheats = {
  list,
  ui,
};
